export default __webpack_public_path__ + "static/media/pantry1-afterA-480w.7c4f50d5.png";